/**
 * Where an item lands when inserted at a divider. Divider `k` is the gap before item `k`, so
 * lifting the item out from before that gap shifts the gap down by one.
 */
export const indexAfterMove = (itemIndex: number, dividerIndex: number): number =>
  itemIndex < dividerIndex ? dividerIndex - 1 : dividerIndex;
